/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { ListContactsQueryResponse, ListContactsQueryParams, ListContactsHeaderParams, ListContacts401 } from "../../models/contactsController/ListContacts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listContactsQueryKey = (params?: ListContactsQueryParams) => [{ url: '/contacts' }, ...(params ? [params] : [])] as const

export type ListContactsQueryKey = ReturnType<typeof listContactsQueryKey>

/**
 * {@link /contacts}
 */
export async function listContacts(params?: ListContactsQueryParams, headers?: ListContactsHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListContactsQueryResponse, ResponseErrorConfig<ListContacts401>, unknown>({ method : "GET", url : `/contacts`, params, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function listContactsQueryOptions(params?: ListContactsQueryParams, headers?: ListContactsHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listContactsQueryKey(params)
        return queryOptions<ListContactsQueryResponse, ResponseErrorConfig<ListContacts401>, ListContactsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return listContacts(params, headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /contacts}
 */
export function useListContacts<TData = ListContactsQueryResponse, TQueryData = ListContactsQueryResponse, TQueryKey extends QueryKey = ListContactsQueryKey>(params?: ListContactsQueryParams, headers?: ListContactsHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<ListContactsQueryResponse, ResponseErrorConfig<ListContacts401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listContactsQueryKey(params)
         

         const query = useQuery({
          ...listContactsQueryOptions(params, headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListContacts401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}